import React from "react"
import tw from "twin.macro"
import ReactModal from 'react-modal'

import Global from "../components/global"
import Page from "../components/page"
import HeaderVideo from "../components/headerVideo"
import TopBar from "../components/topBar"
import TitleEnrolSquare from "../svgs/titleEnrolSquare"
import TitleEnrolLandscape from "../svgs/titleEnrolLandscape"
import EnrolForm from "../components/enrolForm"
import SEO from "../components/seo"

ReactModal.setAppElement('#___gatsby')

const metaDescription = "Enrol for free now and receive more information about our MITO Micro Introduction course to Automotive Engineering."

export default function Form() {
  return (
    <Page>
      <SEO title="Automotive Engineering Course enrolment" description={metaDescription} />
      <Global />
      <HeaderVideo overlay />
      <div
        css={[
          tw`font-sans text-sm flex flex-col items-center justify-center mt-20`,
        ]}
      >
        <TopBar hideEnrolButton={true} enrolButtonClicked={() => {}} />
        <div css={[tw`mb-4`]}>
          <h1>
            <TitleEnrolSquare css={[tw`md:hidden`]} />
            <TitleEnrolLandscape css={[tw`hidden md:block`]} />
          </h1>
        </div>

        <EnrolForm />
      </div>
    </Page>
  )
}
